import React from 'react';

import LinkWithPrevLocation from '@common/react/components/UI/LinkWithPrevLocation/LinkWithPrevLocation';
import Loader from '@common/react/components/Core/LoaderProvider/Loader';

import ShoppingCartInformation from '@app/components/UI/ShoppingCartInformation/ShoppingCartInformation';

const ShoppingCart: React.FC = () => {
	const [init, setInit] = React.useState<boolean>(false);

	React.useEffect(() => {
		setInit(true);
	}, []);

	return <>
		{init
			? <div className="container">
				<ShoppingCartInformation
					checkout={
						<div className="shopping-cart-information__bottom">
							<div className="total">
								<LinkWithPrevLocation to="/ordering" className="btn btn-primary check-out__btn">
									Check out
								</LinkWithPrevLocation>
							</div>
						</div>
					}
				/>
			</div> : <Loader />
		}
	</>;
};

export default ShoppingCart;
